import React from 'react';
import './App.scss';
import { Route, Routes } from 'react-router-dom';
import Home from './home/home';
import Contact from './contact/contact';
import Features from './features/features';
import Legal from './legal/legal';
import Privacy from './legal/privacy';
import NewsletterConfirm1 from './shared/newsletter/newsletter-confirm-1';
import NewsletterConfirm2 from './shared/newsletter/newsletter-confirm-2';
import NewsletterUnsubscribe from './shared/newsletter/newsletter-unsubscribe';
import ScrollToTop from './scroll-to-top';
import PageNotFound from './PageNotFound/PageNotFound';
import Redirector from './redirector/redirector';
import Prices from './prices/prices';
import Education from './education/education';
import FreeTrial from './freetrial/freetrial';
import News from './news/news';
import Features1Management from './features/1/features-1-management';
import Features5Publish from './features/5/features-5-publish';
import Features4Deployment from './features/4/features-4-deployment';
import Features2Analysis from './features/2/features-2-analysis';
import Features3Reporting from './features/3/features-3-reporting';
import Showcases from './showcases/showcases';
import FreeTrialSuccess from './freetrial/freetrial-success';
import OrderSuccess from './prices/order-success';
import ContactSuccess from './contact/contact-success';
import HomeLandingPage from './landing-pages/home/home-landingpage';

function App() {
  return (
    <div className="App light">
      <ScrollToTop /> {/* Add ScrollToTop here */}
      <Routes>
        <Route path="/" element={<Redirector target="/de/home" />} />
        <Route path="home" element={<Redirector target="/de/home" />} />
        <Route path="de/home" element={<Home />} />
        <Route path="en/home" element={<Home />} />

        <Route
          path="spss-kaufen-mit-ps-imago-pro"
          element={<Redirector target="/de/spss-kaufen-mit-ps-imago-pro" />}
        />
        <Route path="de/spss-kaufen-mit-ps-imago-pro" element={<HomeLandingPage />} />
        {/*
        <Route path="help" element={<Help />} />
        <Route path="help-faq" element={<HelpFAQ />} />
        <Route path="help-kb" element={<HelpKB />} />
        <Route path="help-videos" element={<HelpVideos />} />
 */}

        <Route path="features" element={<Redirector target="/de/features" />} />
        <Route path="de/features" element={<Features />} />
        <Route path="en/features" element={<Features />} />
        <Route path="de/features/management" element={<Features1Management />} />
        <Route path="de/features/analysis" element={<Features2Analysis />} />
        <Route path="de/features/reporting" element={<Features3Reporting />} />
        <Route path="de/features/deployment" element={<Features4Deployment />} />
        <Route path="de/features/publish" element={<Features5Publish />} />

        <Route path="showcases" element={<Showcases />} />
        <Route path="showcases/:showcasename" element={<Showcases />} />
        <Route path="de/showcases" element={<Showcases />} />
        <Route path="de/showcases/:showcasename" element={<Showcases />} />
        <Route path="en/showcases" element={<Showcases />} />
        <Route path="en/showcases/:showcasename" element={<Showcases />} />

        <Route path="prices" element={<Redirector target="/de/prices" />} />
        <Route path="kaufen" element={<Redirector target="/de/prices" />} />
        <Route path="preise" element={<Redirector target="/de/prices" />} />
        <Route path="de/prices" element={<Prices />} />
        <Route path="en/prices" element={<Prices />} />
        <Route path="order-success" element={<Redirector target="/de/order-success" />} />
        <Route path="de/order-success" element={<OrderSuccess />} />
        <Route path="en/order-success" element={<OrderSuccess />} />

        <Route path="education" element={<Redirector target="/de/education" />} />
        <Route path="de/education" element={<Education />} />
        <Route path="en/education" element={<Education />} />

        <Route path="freetrial" element={<Redirector target="/de/freetrial" />} />
        <Route path="de/freetrial" element={<FreeTrial />} />
        <Route path="en/freetrial" element={<FreeTrial />} />
        <Route path="freetrial-success" element={<Redirector target="/de/freetrial-success" />} />
        <Route path="de/freetrial-success" element={<FreeTrialSuccess />} />
        <Route path="en/freetrial-success" element={<FreeTrialSuccess />} />

        {/* 
        <Route path="about" element={<Redirector target="/de/about" />} />
        <Route path="de/about" element={<About />} />
        <Route path="en/about" element={<About />} />
        */}

        <Route path="contact" element={<Redirector target="/de/contact" />} />
        <Route path="de/contact" element={<Contact />} />
        <Route path="en/contact" element={<Contact />} />
        <Route path="contact-success" element={<Redirector target="/de/contact-success" />} />
        <Route path="de/contact-success" element={<ContactSuccess />} />
        <Route path="en/contact-success" element={<ContactSuccess />} />

        <Route path="news" element={<Redirector target="/de/news" />} />
        <Route path="de/news/:post" element={<News />} />
        <Route path="de/news" element={<News />} />
        <Route path="en/news/:post" element={<News />} />
        <Route path="en/news" element={<News />} />

        <Route path="impressum" element={<Redirector target="/de/legal" />} />
        <Route path="legal" element={<Redirector target="/de/legal" />} />
        <Route path="de/legal" element={<Legal />} />
        <Route path="en/legal" element={<Legal />} />

        <Route path="privacy" element={<Redirector target="/de/privacy" />} />
        <Route path="datenschutz" element={<Redirector target="/de/privacy" />} />
        <Route path="de/privacy" element={<Privacy />} />
        <Route path="en/privacy" element={<Privacy />} />

        <Route path="newsletter-confirm-1" element={<NewsletterConfirm1 />} />
        <Route path="newsletter-confirm-2" element={<NewsletterConfirm2 />} />
        <Route path="newsletter-unsubscribe" element={<NewsletterUnsubscribe />} />
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </div>
  );
}

export default App;
